import { Episode, Podcast } from '../../types';

const getUrlPathForEpisode = (episode: Episode): string => {
  switch (episode.id.kind) {
    case 'webId':
      return `/dashboard/episode/${episode.id.webId}`;
    case 'id':
      throw new Error('getUrlPathForEpisode: doesnt support id');
    default:
      // eslint-disable-next-line no-case-declarations
      const exhaustiveCheck: never = episode.id;
      return exhaustiveCheck;
  }
};
const getUrlPathForEditPodcast = (): string => '/dashboard/podcast/edit';

const getUrlPathForPodcastPublicProfile = (podcast: Podcast): string =>
  `/${encodeURIComponent(podcast.vanitySlug)}`;

const getUrlPathForPodcastEmbed = (podcast: Podcast): string =>
  `/${encodeURIComponent(podcast.vanitySlug)}/embed`;

const getUrlPathForMoney = (): string => '/dashboard/money';

const getUrlPathForEditEpisode = (episodeId: string): string =>
  `/dashboard/episode/${episodeId}/metadata/edit`;

/**
 * @deprecated
 */
const AnchorClientRoutes = {
  getUrlPathForEditEpisode,
  getUrlPathForEditPodcast,
  getUrlPathForEpisode,
  getUrlPathForMoney,
  getUrlPathForPodcastEmbed,
  getUrlPathForPodcastPublicProfile,
};

export { AnchorClientRoutes };
